import React from 'react';
import { authRouteConfig } from './auth';
import { initialUrl } from 'shared/constants/AppConst';
import { Navigate } from 'react-router-dom';
import Error403 from './errorPages/Error403';
import { errorPagesConfigs } from './errorPages';
import { accountPagesConfigs } from './account';
import { dashboardConfigs } from './Dashboard';
import { componentsConfigs } from './Components';
import { dataPegawaiConfigs } from './DataPegawai';
import { laporanUmumConfigs } from './LaporanUmum';
import { manajemenConfigs } from './Manajemen';
import { skpConfigs } from './SKP';
import { masterdataConfigs } from './Masterdata';
import { pengaturanConfigs } from './Pengaturan';
import { logbookConfigs } from './Logbook';
import { slksConfigs } from './SLKS';
import { monitoringConfigs } from './MonitoringDataSIASN';
import { dataPribadiConfigs } from './DataPribadi';
import { umpanBalik360Configs } from './UmpanBalik360';
import { profilTalentaConfigs } from './ProfilTalenta';
import { dashboardPresensiConfigs } from './DashboardPresensi';

const authorizedStructure = {
  fallbackPath: '/redirect',
  unAuthorizedComponent: <Error403 />,
  routes: [
    ...authRouteConfig,
    ...dataPegawaiConfigs,
    ...accountPagesConfigs,
    ...dashboardConfigs,
    ...componentsConfigs,
    ...laporanUmumConfigs,
    ...skpConfigs,
    ...manajemenConfigs,
    ...masterdataConfigs,
    ...pengaturanConfigs,
    ...logbookConfigs,
    // ...presensiConfigs,
    ...slksConfigs,
    ...monitoringConfigs,
    ...dataPribadiConfigs,
    ...umpanBalik360Configs,
    ...profilTalentaConfigs,
    ...dashboardPresensiConfigs,
  ],
};

const unAuthorizedStructure = {
  fallbackPath: window.location.pathname,
  routes: authRouteConfig,
};

const anonymousStructure = {
  routes: errorPagesConfigs.concat([
    ...authRouteConfig,
    {
      path: '/',
      element: <Navigate to={initialUrl} />,
    },
    {
      path: '*',
      element: <Navigate to='/error-pages/error-404' />,
    },
  ]),
};

export { authorizedStructure, unAuthorizedStructure, anonymousStructure };
